import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <footer className="bg-gray-950 pt-16 pb-8 border-t-2 border-kitty-yellow" data-id="element-50" data-mp="3qcdux6xomlv1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51" data-mp="29ynmjnzj5bfl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-52" data-mp="2a1jm1gr10865">
          <div className="col-span-1 md:col-span-2" data-id="element-53" data-mp="2ezut5jpxs4ko">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-54" data-mp="3l90m9rokaqx5">
              <div className="bg-white rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-55" data-mp="3lbmvrwv0jgi0">
                <img src="https://cdn.magicpatterns.com/uploads/vpaWAD2nLEfW1hoAd36jz7/LPot_only.png" alt="KittyPot logo" className="w-[26px] h-[26px] object-contain" data-id="element-56" data-mp="3gck196cnssoa" />
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-57" data-mp="3q7bxa5qlf7gy">
                KittyPot
              </span>
            </Link>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-58" data-mp="34723g4s9vvk">
              KittyPot helps groups track shared expenses, split costs fairly,
              and see the simplest way to settle up.
            </p>
            <div className="flex gap-4" data-id="element-59" data-mp="ct765dy57hgm">
              <a href="https://www.linkedin.com/company/kitty-pot/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors" data-id="element-60" data-mp="cu8sieklzqdn">
                <Linkedin className="w-5 h-5" data-id="element-61" data-mp="twfp9wj4m1th" />
              </a>
              <a href="https://www.facebook.com/people/Kittypotapp/100089385062763/?rdid=MRuINit14xpTUSpr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1SAZAsYsVG%2F" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors" data-id="element-62" data-mp="ytxylo122j20">
                <Facebook className="w-5 h-5" data-id="element-63" data-mp="1cnoz66wt6sll" />
              </a>
              <a href="https://www.instagram.com/kittypotapp?igsh=Nm53NnEzemxqcjl5" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors" data-id="element-64" data-mp="1hje28k81ermn">
                <Instagram className="w-5 h-5" data-id="element-65" data-mp="3obx2lev1v0vx" />
              </a>
            </div>
          </div>

          <div data-id="element-66" data-mp="3t9gfobg0h7ma">
            <h4 className="font-bold text-kitty-yellow mb-4" data-id="element-67" data-mp="3tb19tzyeyojm">Product</h4>
            <ul className="space-y-3" data-id="element-68" data-mp="2afn7ky1dnbtf">
              <li data-id="element-69" data-mp="2agop9lcwewk4">
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-70" data-mp="2agye35m7ixo8">
                  How it works
                </button>
              </li>
              <li data-id="element-71" data-mp="1wnp5h7632g6r">
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-72" data-mp="1woi6drid2bgz">
                  Features
                </button>
              </li>
              <li data-id="element-73" data-mp="2pdfp1vqhiaa9">
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-74" data-mp="2pcw6cct0fhv6">
                  FAQ
                </Link>
              </li>
              <li data-id="element-75" data-mp="2feq4twb48dqu">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-76" data-mp="2fd5aa6oswusz">
                  About Us
                </Link>
              </li>
              <li data-id="element-77" data-mp="13z1i961rxgqk">
                <button onClick={() => scrollToSection('waitlist')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-78" data-mp="13yiagi5u88q9">
                  Join waitlist
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-79" data-mp="2wnr46yk2b17p">
            <h4 className="font-bold text-kitty-yellow mb-4" data-id="element-80" data-mp="2woamigdmjrm9">Legal</h4>
            <ul className="space-y-3" data-id="element-81" data-mp="2iwmccimxrd7x">
              <li data-id="element-82" data-mp="2nu5ptgbt7lyt">
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-83" data-mp="2ntmh8q81u9xg">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-84" data-mp="3flbpjvnmbhnk">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors" data-id="element-85" data-mp="3fltudgocj473">
                  Terms and Conditions
                </Link>
              </li>
              <li data-id="element-86" data-mp="36knbj0y85hao">
                <Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-87" data-mp="36k44ifa44dbf">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-88" data-mp="1v5gww4kwqmy5">
                <Link to="/disclaimer" className="text-gray-400 hover:text-white transition-colors" data-id="element-89" data-mp="1v6034o173mwc">
                  Disclaimer
                </Link>
              </li>
              <li data-id="element-90" data-mp="1nnshnzut056f">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-91" data-mp="1in4ob7j3rc91">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/[0.08] flex flex-col items-center gap-4 text-center" data-id="element-92" data-mp="1rn16qrewfevn">
          <p className="text-gray-400 text-sm max-w-2xl" data-id="element-93" data-mp="13x704rl6amju">
            Current MVP: expense tracking and manual settlement only. KittyPot
            does not hold or move money.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 w-full mt-4" data-id="element-94" data-mp="1dob8v9k99b68">
            <p className="text-gray-500 text-sm" data-id="element-95" data-mp="18wta8s5pfmof">
              © {new Date().getFullYear()} KittyPot Ltd. All rights reserved.
              Company Reg. 13695043
            </p>
            <p className="text-gray-500 text-sm" data-id="element-96" data-mp="g8noc22wzrn0">Designed in the UK 🇬🇧</p>
          </div>
        </div>
      </div>
    </footer>;
}